import Component from "./DynamicFiltersWrapper";
export default Component;
